'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const presencesDonations = {
  settings: {
    $accordionTable: document.querySelectorAll('[data-accordion]'),
    $fixedTable: document.querySelectorAll('[data-accordion]'),
    $donationContainer: document.getElementById('donation'),
    $controlInput: document.getElementById('customRadio1'),
    $form: $('.js-form-donations'),
  },

  accordion() {
    s.$accordionTable.forEach(el => {
      if (el.querySelector('thead')) {
        el.querySelector('thead').addEventListener('click', () => {
          el.classList.contains('is-opened') ? el.classList.remove('is-opened') : el.classList.add('is-opened');

          setTimeout(() => {
            window.scrollTo({
              top: el.nextElementSibling.offsetTop - 130,
              behavior: 'smooth',
            });
          }, 300);
        });
      }
    });
  },

  fixedTableHeader() {
    s.$donationContainer.classList.add('fixed-initialized');

    if (window.innerWidth > 768) {
      s.$fixedTable.forEach(el => {
        if (el.querySelector('thead')) {
          let w = el.clientWidth;

          window.addEventListener('scroll', e => {
            if (el.getBoundingClientRect().top - 70 <= 0 && el.classList.contains('is-opened')) {
              el.classList.add('fixed');
              el.querySelector('thead').style.width = `${w}px`;
            } else {
              el.classList.remove('fixed');
            }
          });
        }
      });
    }
  },

  bindActions() {
    $('.custom-control-input').on('change', function(e) {
      if (this.value == 1) {
        $('#' + $(this).attr('data-id')).removeClass('u-display--none');
        if (!s.$donationContainer.classList.contains('fixed-initialized')) {
          _this.fixedTableHeader();
        }
      } else {
        $('#' + $(this).attr('data-id')).addClass('u-display--none');
        $('#' + $(this).attr('data-id'))
          .find('input:text')
          .val('');
      }
    });

    $('.js-item').on('blur', function(e) {
      let $input = $(this);
      const $row = $input.parent().parent();
      let value = $input.val();

      const roof = parseFloat($input.attr('data-roof'));
      const points = parseFloat($input.attr('data-points'));
      let totalPoints = null;

      if (value > roof) {
        totalPoints = roof * points;
      } else {
        totalPoints = value * points;
      }

      $('.total_points', $row).text(totalPoints);

      return true;
    });

    s.$form.on('submit', function(e) {
      if ($("input[name='make_donation']:checked").val() == 1) {
        e.preventDefault();
        let submitForm = false;
        var count = 0;

        $('.js-item').each(function(i, el) {
          if (el.value.length > 0) {
            count++;
          }
        });

        if (count == 0) {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            text: 'Preencha pelo menos 1 item de doação!',
          });
          submitForm = false;
          return false;
        }

        submitForm = true;

        if (submitForm) {
          e.target.submit();
        }
      }
    });

    $('.js-donations-save').on('click', function(e) {
      e.preventDefault();

      $.ajax({
        type: 'POST',
        url: s.$form[0].action,
        data: s.$form.serialize(),
        dataType: 'json',
        success: function(data) {
          if (data.success) {
            Swal.fire({
              icon: 'success',
              title: data.title,
            });
          }
        },
      });
    });
  },

  init() {
    _this.bindActions();
    _this.accordion();

    if (s.$controlInput.checked) {
      _this.fixedTableHeader();
    }
  },
};

const _this = presencesDonations,
  s = _this.settings;

export default presencesDonations;
